export default __webpack_public_path__ + "dde1d66354d64d833681ec0716ad0587.ttf";